import React from "react";

const Avatar = ({ src, size = 24 }) => {
  if (src && src.startsWith('http')) {
    return <img src={src} alt="" style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover' }} />;
  }
  return <span style={{ fontSize: size }}>{src || '👤'}</span>;
};

export default Avatar;
